<template>
	<div class='knd-story'>
		<Percentage
			:achtergrondKleur='"#2A3700"'
			:vulKleur='"#F4FFE7"' />

		<paragraafIntro :data="intro"></paragraafIntro>

		<div class="knd-story-container">
			<component 
				v-for="(paragraaf, index) in paragrafen" 
				:key="'paragraaf-' + index" 
				:is="'paragraaf' + paragraaf.type[0].titel"
				:data="paragraaf">
			</component>


			<div v-if="environment === 'development' || environment === 'test'">
				<div class="knd-timestamp" >
					{{ this.$store.state.data.timestamp }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import paragraafAudio from '@/components/paragraaf/audio';
import paragraafScrolly from '@/components/paragraaf/scrolly';
import paragraafAchtergrond from '@/components/paragraaf/achtergrond';
import paragraafColofon from '@/components/paragraaf/colofon';
import paragraafIntro from '@/components/paragraaf/intro';
import paragraafInstanties from '@/components/paragraaf/instanties';

import Percentage from '@/components/percentage';


import './scss/index.scss'

export default {
	name: 'App',
	components: {
		paragraafAudio,
		paragraafScrolly,
		paragraafAchtergrond,
		paragraafColofon,
		paragraafIntro,
		paragraafInstanties,
		Percentage
	},
	data() {
		let paragrafen = this.$store.state.data['paragrafen'];
		paragrafen = paragrafen.filter(item => item.type[0].titel);

		return {
			intro: {tekst: this.$store.state.data.intro, disclaimer: this.$store.state.data.intro_disclaimer},
			paragrafen: paragrafen,
			environment: process.env.NODE_ENV,
		}
	},
	mounted: function() {
	},
	methods: {
	}
}
</script>
